import { styled } from '@mgmresorts/wcl-styled';
import { display, flexWrap, flexDirection, alignItems, justifyContent, width, minWidth, maxWidth, height, minHeight, maxHeight, fontSize, lineHeight, textAlign, flex, order, alignSelf, top, right, bottom, left, zIndex, opacity, borderRadius } from '../../../../node_modules/styled-system/dist/index.esm.es.js';
import { space } from '../../../../node_modules/@styled-system/space/dist/index.esm.es.js';
import { color } from '../../../../node_modules/@styled-system/color/dist/index.esm.es.js';
import { shadow } from '../../../../node_modules/@styled-system/shadow/dist/index.esm.es.js';
import { background } from '../../../../node_modules/@styled-system/background/dist/index.esm.es.js';
import { position } from '../../../../node_modules/@styled-system/position/dist/index.esm.es.js';

/**
 * Box element equipped in [styled-system](https://github.com/styled-system/styled-system) props that help you quickly declare css.
 * See [styled-system API docs](https://styled-system.com/api/) for more info.
 */

var Box = styled.div(display, flexWrap, flexDirection, alignItems, justifyContent, space, width, minWidth, maxWidth, height, minHeight, maxHeight, fontSize, lineHeight, textAlign, color, flex, order, alignSelf, shadow, background, position, top, right, bottom, left, zIndex, opacity, borderRadius);

export { Box };
